import {
  type Subdomain,
  BUSINESS_SUBDOMAIN,
  SUBDOMAINS,
} from 'constants/subdomains';

export const getSubdomain = (): Subdomain => {
  if (!process.env.NEXT_PUBLIC_SUBDOMAIN)
    throw Error('SUBDOMAIN env variable is not set');

  const subdomain = validateSubdomain(process.env.NEXT_PUBLIC_SUBDOMAIN);

  return subdomain;
};

const isValidSubdomain = (subdomain: string): subdomain is Subdomain =>
  (SUBDOMAINS as readonly string[]).includes(subdomain);

const validateSubdomain = (subdomain: string): Subdomain => {
  if (!isValidSubdomain(subdomain)) throw Error('subdomain is not valid');
  return subdomain;
};

export const isSubdomainBusiness = () => {
  const subdomain = getSubdomain();
  return subdomain === BUSINESS_SUBDOMAIN;
};
